/** @format */
import angular from 'angular';
import jsData from 'js-data-angular';
import _ from 'lodash';

init.$inject = ['$http', '$log', 'specialisationStudiesClassificationJSDataModel'];
defineResource.$inject = ['DS'];

export const specialisationStudiesClassificationModule = 'sis-components.model.specialisationStudiesClassification';

angular
    .module(specialisationStudiesClassificationModule, [jsData])
    .factory('specialisationStudiesClassificationJSDataModel', defineResource)
    .run(init);

function defineResource(DS) {
    return DS.defineResource({
        idAttribute: 'urn',
        name: 'specialisationStudiesClassification',
        endpoint: '/kori/api/cached/codebooks/urn:code:specialisation-studies-classification',
        watchChanges: false,
    });
}

function init($http, $log, specialisationStudiesClassificationJSDataModel) {
    $http
        .get(specialisationStudiesClassificationJSDataModel.endpoint)
        .then(response => specialisationStudiesClassificationJSDataModel.inject(_.values(response.data)))
        .catch(error => $log.error(error));
}
